import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ng-kernel';
import * as _4 from 'lodash4';

export interface IStandaloneNavigation {
  userId?: number;
  apiCurrentTerm?: number | null;
}

export type TStandaloneNavigationModel = ITypedModel<IStandaloneNavigation>;

angular.module('capability-ng-scheduler').factory(
  'ngStandaloneNavigationModel',
  () =>
    new Model<IStandaloneNavigation>({
      userId: undefined,
      apiCurrentTerm: undefined
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/standalone_scheduler/models/standalone_navigation_model.ts